import React, { useContext, useEffect, useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import debounce from 'lodash.debounce'
import {getWordCountFromText, removeSpecialCharacters} from '../../../lib/utils'
import { AccountContext } from '../../../providers/accountProvider'

const MyEditor = ({ content, updateWordCount }) => {
  const editorRef = useRef(null);
  const { user } = useContext(AccountContext)

  const handleEditorChange = () => {
    const editor = window.tinymce.activeEditor
    // const wordCount = editor.plugins.wordcount.getCount()
    // updateWordCount(wordCount)
    if (!editor) return
    const plainText = editor.getContent({ format: 'text' })
    const count = getWordCountFromText(removeSpecialCharacters(plainText))
    updateWordCount(count);
  }
  useEffect(() => {
    if(user?.location === 'US'){
      let scriptEle = document.createElement("script");
      scriptEle.setAttribute("src", 'https://svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js');
      scriptEle.setAttribute("type", "text/javascript");
      document.body.appendChild(scriptEle);
      window.WEBSPELLCHECKER_CONFIG = {
        "autoSearch": true,
        "autoDestroy": true,
        "autocorrect": true,
        "autocomplete": true,
        "enforceAI": true,
        "ignoreWordsWithNumbers": false,
        "removeBranding" : true,
        "serviceId": "GLU5rtjbYaeeXaB",
        "serviceProtocol": "https",
        "servicePort": "443",
        "serviceHost": "svc.webspellchecker.net",
        "servicePath": "api",
        "actionItems": [
          "ignoreAll",
          "addWord",
          "ignore",
          "toggle",
          "proofreadDialog"
        ],
      }
  
    }
  },[])

  const delayedHandleEditorChange = debounce(handleEditorChange, 1000);


  return (
      <>
          <Editor
            id="editor"
            initialValue={content}
            // onInit={(evt, editor) => {editorRef.current = editor;console.log(editor);}}
            onInit={(evt, editor) => {
              editorRef.current = editor;
              if(user?.location === 'US'){
                window.WEBSPELLCHECKER.init({
                  container: editor.iframeElement
                })
              }
              editor.focus()
              handleEditorChange()
            }}
            onEditorChange={delayedHandleEditorChange}
            selector="textarea"
            apiKey="zbbryxi5kv4tdgq6s2l2wso42dv4oj0uwrfh8ls403w4j09o"
            init={{
              // inline: true,
              height: 500,
              skin: "naked",
              // toolbar: [
              //   'undo redo | styleselect | bold italic | link image',
              //   'alignleft aligncenter alignright'
              // ],
              // toolbar1: 'undo redo | styleselect | bold italic | link image',
              // toolbar2: 'alignleft aligncenter alignright',
              menubar: false,
              branding: false,
              resize: false,
              statusbar: false,
              toolbar: 'bold italic | alignleft aligncenter alignright alignjustify',
              // toolbar: true,
              plugins: [
                'advlist autolink lists',
                'charmap print preview anchor help',
                'searchreplace visualblocks code save',
                'insertdatetime media table paste wordcount',
              ]
            }}
            name="body"
            // onEditorChange={this.handleEditorChange}
          />
      </>
  )
}

export default MyEditor

export const getContent = () => {
  if (!window.tinymce) return ''
  const editor = window.tinymce.activeEditor
  if (!editor) return ''
  return editor.getContent();
}
export const getPlainContent = () => {
  if (!window.tinymce) return ''
  const editor = window.tinymce.activeEditor
  if (!editor) return ''
  return editor.getContent({ format: 'text' });
}
export const isContentChanged = () => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  return editor.isDirty()
}
export const resetIsContentChanged = (status=false) => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  editor.setDirty(status)
}
export const isRedoEmpty = () => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  if (!editor.undoManager) return
  return !editor.undoManager.hasRedo()
}
export const isUndoEmpty = () => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  if (!editor.undoManager) return
  return !editor.undoManager.hasUndo()
}
export const handleUndo = () => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  if (!editor.undoManager) return
  editor.undoManager.undo()
}
export const handleRedo = () => {
  if (!window.tinymce) return
  const editor = window.tinymce.activeEditor
  if (!editor) return
  if (!editor.undoManager) return
  editor.undoManager.redo()
}
